import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FormArray, FormControl} from '@angular/forms';
import {
  StreamTranscodingOption
} from '../../../pages/manage-destination/components/manege-destination-form/manege-destination-form.component';
import {UUID} from '../../types/uuid.type';
import {MatSelectionListChange} from '@angular/material/list';

@Component({
  selector: 'app-destination-hls-ladder-form',
  templateUrl: './destination-hls-ladder-form.component.html',
  styleUrls: ['./destination-hls-ladder-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DestinationHlsLadderFormComponent implements OnChanges {
  @Input() public streamTranscodings: StreamTranscodingOption[] = [];
  @Input() public selectedTranscodings: FormArray<FormControl<UUID>> = new FormArray<FormControl<UUID>>([]);
  @Input() public includeOriginStream: FormControl<boolean> = new FormControl<boolean>(false);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['streamTranscodings']) {
      this.removeUnavailableSelections();
    }
  }

  public isSelectedTranscoding(id: UUID): boolean {
    const selectedIds: UUID[] = this.selectedTranscodings.controls
      .map((control: FormControl<UUID>): UUID => control.value as UUID);

    return selectedIds.includes(id);
  }

  public get isSelectedOriginStream(): boolean {
    return this.includeOriginStream.value;
  }

  public onSelectionChange(change: MatSelectionListChange): void {
    const availableIds: UUID[] = this.streamTranscodings
      .map((transcoding: StreamTranscodingOption): UUID => transcoding.id as UUID);

    for (const option of change.options) {
      const value: UUID | 'origin' = option.value;
      const isSelected: boolean = option.selected;

      if (value === 'origin') {
        this.includeOriginStream.patchValue(isSelected);
        continue;
      }

      const isAvailable: boolean = availableIds.includes(value);
      if (!isAvailable) {
        continue;
      }

      const index: number = this.selectedTranscodings.controls
        .findIndex((control: FormControl<UUID>): boolean => control.value === value);

      if (isSelected && index === -1) {
        const control: FormControl<UUID> = new FormControl(value);
        this.selectedTranscodings.push(control);
      }

      if (!isSelected && index !== -1) {
        this.selectedTranscodings.removeAt(index);
      }
    }
  }

  private removeUnavailableSelections(): void {
    const ids: UUID[] = this.streamTranscodings
      .map((transcoding: StreamTranscodingOption): UUID => transcoding.id as UUID);

    for (let i: number = this.selectedTranscodings.length - 1; i >= 0; i--) {
      const value: UUID = this.selectedTranscodings.at(i).value;
      if (!ids.includes(value)) {
        this.selectedTranscodings.removeAt(i);
      }
    }
  }
}
